import { axiosInstance } from "../../../utils";
import constants from "./constants";
async function createReverseNote(postObj) {
  const res = await axiosInstance.post(constants.REVERSE_POST_URL, postObj);

  return res;
}

export { createReverseNote };
